const initialState = {
  isRTL: false,
  language: ''
}

export const home = {
  namespaced: true,
  state: initialState,
  actions: {
    setIsRTL ({ commit }, isRTL) {
      commit('setIsRTL', isRTL)
    },
    setLanguage ({ commit }, language) {
      commit('setLanguage', language)
    }
  },
  mutations: {
    setIsRTL (state, isRTL) {
      console.log(isRTL)
      state.isRTL = isRTL
    },
    setLanguage (state, language) {
      state.language = language
    }
  },
  getters: {
    isRTL: (state) => {
      return state.isRTL
    },
    language: (state) => {
      return state.language
    }
  }
}
